// @owners { team: patients }
import { useNavigationContext } from '~web/contexts';

const isHubReferralInfoRoute = (pathname: string | null | undefined) => {
  return Boolean(pathname?.startsWith('/info/'));
};

export const useIsHubReferralInfoRoute = () => {
  const { current, previous: previousPath } = useNavigationContext();
  const currentPath = current?.pathname;

  return {
    isHubReferralInfoRoute: isHubReferralInfoRoute(previousPath) || isHubReferralInfoRoute(currentPath),
  };
};
